<template>
  <div id="uppy">
    <div class="for-DragDrop"></div>
    <div class="for-ProgressBar my-2"></div>
  </div>
</template>

<script>
  // uppy.io core, plugins & locales
  import Uppy from '@uppy/core'
  import DragDrop from '@uppy/drag-drop'
  import ru_RU from '@uppy/locales/lib/ru_RU'
  import StatusBar from '@uppy/status-bar'
  import Tus from '@uppy/tus'

  export default {
    name: "UppyWidget",
    props: {
      uploadUrl: {
        type: String,
        required: true
      },
      chunkSize: {
        type: [Number, String],
        required: true
      },
      opts: {
        type: Object,
        default: () => Object({
          debug: true,
          autoProceed: true,
          allowMultipleUploads: true,
          locale: ru_RU,
          restrictions: {
            allowedFileTypes: ['video/*', '.mp4'],
            minNumberOfFiles: 1,
            maxNumberOfFiles: 10
          }
        })
      }
    },
    computed: {
      tusOptions() {
        return {
          chunkSize: Number(this.chunkSize),
          endpoint: this.uploadUrl,
          withCredentials: true
        }
      },
      drapDropOptions() {
        return {
          target: '#uppy .for-DragDrop',
          locale: {
            strings: {
              dropHereOr: 'Перетащите видео файлы (например .mov, .mp4, .mkv) сюда или %{browse}',
              browse: 'выберите их самостоятельно'
            }
          }
        }
      },
      uppyInstance() {
        return this.uppy
      }
    },
    mounted() {
      this.initUppy()
    },
    methods: {
      initUppy() {
        this.uppy = new Uppy(this.opts);

        this.uppy
          .use(DragDrop, this.drapDropOptions)
          .use(Tus, this.tusOptions)
          .use(StatusBar, {
            target: '#uppy .for-ProgressBar',
            hideAfterFinish: false,
            hideUploadButton: true
          })
          .on('complete', ($el) => {
            // console.log($el);
            this.$emit('complete', $el);
          })
      }
    }
  }
</script>

<style>
  @import '../../../node_modules/@uppy/core/dist/style.css';
  @import '../../../node_modules/@uppy/drag-drop/dist/style.css';
  @import '../../../node_modules/@uppy/status-bar/dist/style.css';
</style>
